import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      id: 1,
      icon: 'Shield',
      label: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      id: 2,
      icon: 'Lock',
      label: 'SOC 2 Compliant',
      description: 'Type II certified'
    },
    {
      id: 3,
      icon: 'CheckCircle2',
      label: 'GDPR Ready',
      description: 'Data protection'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-center gap-2">
        <div className="h-px flex-1 bg-border" />
        <span className="text-xs font-caption text-muted-foreground uppercase tracking-wider">
          Enterprise Security
        </span>
        <div className="h-px flex-1 bg-border" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
        {securityFeatures?.map((feature) => (
          <div
            key={feature?.id}
            className="flex flex-col items-center gap-2 p-3 md:p-4 bg-muted/50 rounded-md border border-border hover:bg-muted transition-smooth"
          >
            <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary/10">
              <Icon name={feature?.icon} size={20} className="text-primary" />
            </div>
            <div className="text-center">
              <p className="text-xs md:text-sm font-medium text-foreground">
                {feature?.label}
              </p>
              <p className="text-xs text-muted-foreground font-caption mt-0.5">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityBadges;